import useSettings from '../../../hooks/useSettings';

/* ============================================================================
   Claro / escuro na faixa superior.

   Substitui o painel de aparencia inteiro (a engrenagem flutuante), removido em
   10/09/2026. Dos quatro ajustes que aquele painel oferecia, tres nao eram
   decisao de ninguem - largura sempre total, cor sempre a do sistema, layout
   nunca trocado - e ficavam ali cobrando escolha de quem entrou para trabalhar.
   Claro/escuro e o unico que muda de pessoa para pessoa (e de sala para sala),
   entao ele fica, como UM botao, onde a pessoa ja olha.

   O ICONE MOSTRA O DESTINO, e nao o estado atual: no tema claro aparece a lua
   ("clicar leva ao escuro"). E a convencao dos sistemas operacionais, e evita a
   leitura ambigua de um sol que tanto pode significar "estou no claro" quanto
   "clique para clarear". O `title` e o `aria-label` dizem a mesma coisa em
   palavras, porque icone sozinho nao e rotulo.
   ============================================================================ */

export default function BotaoTema() {
  const { themeMode, onToggleMode } = useSettings();
  const escuro = themeMode === 'dark';
  const rotulo = escuro ? 'Mudar para o tema claro' : 'Mudar para o tema escuro';

  return (
    <button
      type="button"
      onClick={onToggleMode}
      title={rotulo}
      aria-label={rotulo}
      aria-pressed={escuro}
      className="grid h-8 w-8 place-items-center rounded-md text-primary-foreground/80 transition-colors hover:bg-primary-foreground/10 hover:text-primary-foreground"
    >
      {escuro ? (
        /* sol - clicar volta para o claro */
        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" aria-hidden>
          <circle cx="12" cy="12" r="4.2" stroke="currentColor" strokeWidth="1.7" />
          <path
            d="M12 2.6v2.4M12 19v2.4M2.6 12H5m14 0h2.4M5.3 5.3l1.7 1.7m10 10l1.7 1.7m0-13.4l-1.7 1.7m-10 10l-1.7 1.7"
            stroke="currentColor"
            strokeWidth="1.7"
            strokeLinecap="round"
          />
        </svg>
      ) : (
        /* lua - clicar leva ao escuro */
        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" aria-hidden>
          <path
            d="M20 14.2A8.4 8.4 0 019.8 4 8.4 8.4 0 1020 14.2z"
            stroke="currentColor"
            strokeWidth="1.7"
            strokeLinejoin="round"
          />
        </svg>
      )}
    </button>
  );
}
